import * as React from 'react'
import { ResetPasswordSentMain } from './ResetPasswordSentMain'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ResetPasswordSentMainExamples = () => {
  return (
    <div className="ResetPasswordSentMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ResetPasswordSentMain />
      </Provider>
    </div>
  )
}
